// extracted by mini-css-extract-plugin
export default {"specific":"MapyCzComponents_specific__OYT5H","attribution":"MapyCzComponents_attribution__UckV9"};